<template>
  <div>
    <w-tool-tabs class="tab-button" v-model="activeChildTab">
      <el-tab-pane v-for="tab in tabList" :key="tab.name" :label="tab.label" :name="tab.name" class="h100 w100">
        <component :is="tab.name" :active-tab="activeChildTab" :ref="tab.name"></component>
      </el-tab-pane>
    </w-tool-tabs>
  </div>
</template>

<script>
import WVmManagement from './components/VmManagement';
import WTemplateManagement from './components/TemplateManagement';

export default {
  name: 'WVmTemplateManagement',
  components: {
    WVmManagement,
    WTemplateManagement,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      tabList: [
        { label: 'VM', name: 'WVmManagement' },
        { label: '템플릿', name: 'WTemplateManagement' },
      ],
      activeChildTab: 'WVmManagement',
    };
  },
  watch: {
    activeChildTab() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (this.activeTab === this.$options.name) {
        this.$nextTick(() => {
          const activeChildTab = this.activeChildTab;
          const activeCmp = this.$refs[activeChildTab];
          if (activeCmp.length > 0) {
            this.$refs[activeChildTab][0].loadData();
          } else {
            this.activeTab = this.tabList[0].name;
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/VmTemplateManagement.vue